<template>
    <div class="brand-detail-container">
        <!--        <div v-wechat-title="$route.meta.title=detailData.logo"></div>-->
        <div style="background-color: #000000;">
            <img class="brand-show" :src="detailData.images" />
            <div style="position: absolute; top: 40px;bottom: 0;right: 0;left: 0; margin: 0 auto;text-align: center;">
                <img class="brand-show-logo" :src="detailData.logo" />
                <div class="brand-show-name">{{ detailData.name }}</div>
                <div class="brand-show-merchantCompanyName">
                    {{ detailData.merchantCompanyName }}
                    <span class="brand-show-label" v-for="label in detailData.labels" :key="label.id">{{ label.name
                    }}</span>
                </div>
            </div>
        </div>
        <div class="card-boxTwo brand-detail-top">
            <!--            <div class="top-box">-->
            <!--                <div class="top-left">-->
            <!--                    <div class="name">{{detailData.name}}</div>-->
            <!--                    <div class="merchantCompanyName">{{detailData.merchantCompanyName}}</div>-->
            <!--                    <div style="margin-top: 24px">-->
            <!--                        <span class="label" v-for="label in detailData.labels" :key="label.id">{{ label.name }}</span>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--                <img class="brand-logo" :src="detailData.logo" />-->
            <!--            </div>-->
            <div class="bottom-box-brand">
                <div class="item">
                    <span class="value">{{ detailData.taskCount }}</span>
                    <span class="label">任务数</span>
                </div>
                <div class="item">
                    <span class="value">{{ detailData.attentionCount }}</span>
                    <span class="label">粉丝量</span>
                </div>
                <div class="item" @click="handleAttentionChange">
                    <img class="value" style="width: 22px; height: 20px" v-if="
                        detailData.attentionFlag &&
                        detailData.attentionFlag.value === 0
                    " src="../assets/taskDetail/not.png" />
                    <img class="value" style="width: 22px; height: 20px" v-else src="../assets/taskDetail/like.png" />
                    <span class="label">收藏</span>
                </div>
                <!--                <div class="item">-->
                <!--                    <img class="value" style="width: 20px;height: 20px" src="../assets/taskDetail/share.png" />-->
                <!--                    <span open-type="share" class="label">分享</span>-->
                <!--                </div>-->
                <!--                <div class="item" bindtap="handleAttentionChange">-->
                <!--                    <template v-if="detailData.attentionFlag.value === 0">-->
                <!--                        <img src="../../images/brand/Heart.png" />-->
                <!--                        <span class="label">关注</span>-->
                <!--                    </template>-->
                <!--                    <template v-else>-->
                <!--                        <img src="../../images/brand/Hearted.png" />-->
                <!--                        <span class="label">已关注</span>-->
                <!--                    </template>-->
                <!--                </div>-->
                <!--                <div class="item share-btn">-->
                <!--                    <img src="../../images/brand/share.png" />-->
                <!--                    <span class="label">分享</span>-->
                <!--                    <button open-type="share" class="share-btn-opacity">分享</button>-->
                <!--                </div>-->
            </div>
        </div>

        <div class="brand-introduction card-box" style="margin-top: 10px">
            <div class="brand-introduction-title">品牌简介</div>
            <div class="richText" v-html="detailData.introduction"></div>
            <!--            <span class="brand-introduction-detail">{{detailData.introduction}}</span>-->
        </div>

        <div class="brand-tabs-container">
            <van-tabs v-model="currentTab" @click="onChange">
                <van-tab title="品牌详情" name="品牌详情">
                    <div class="info-container">
                        <!--                        <div class="title">品牌简介</div>-->
                        <!--                        <span class="introduction">{{detailData.introduction}}</span>-->
                    </div>
                </van-tab>
                <van-tab title="进行中任务" name="进行中任务">
                    <div class="info-container">
                        <span class="item-title"></span>
                    </div>
                </van-tab>

                <van-tab title="已完成任务" name="已完成任务">
                    <div class="info-container">
                        <span class="item-title"></span>
                    </div>
                </van-tab>
            </van-tabs>
        </div>

        <template v-if="currentTab === '品牌详情'">
            <div class="card-box">
                <div class="brand-detail-title">详细介绍</div>
                <div class="richspan" v-html="detailData.description"></div>
            </div>
        </template>
        <!-- start -->
        <!-- <template v-else>
            <van-pull-refresh
                class="card-box"
                v-model="refreshing"
                @refresh="onRefresh"
            >
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="handleGetTaskList"
                >
                    <div v-for="item in taskList" :key="item.id">
                        <div
                            class="item-container"
                            @click="onTapItem(item.id, item.instantGuestFlag)"
                        >
                            <div class="b-logo">
                                <van-image
                                    use-loading-slot
                                    :src="item.productsImageUrl"
                                >
                                    <van-loading
                                        slot="loading"
                                        type="spinner"
                                        size="20"
                                        vertical
                                    />
                                </van-image>
                            </div>
                            <div class="task-content">
                                <span class="task-title">{{ item.name }}</span>
                                <div class="task-platform">
                                    <div class="sign-total">
                                        <div
                                            v-if="item.exemptEmployFlag === 1"
                                            class="label-sign"
                                        >
                                            100%录用
                                        </div>
                                        <div
                                            v-if="item.instantGuestFlag"
                                            class="label-sign"
                                        >
                                            现场做现场得
                                        </div>
                                    </div>
                                </div>
                                <div class="task-m">
                                    <template>
                                        <span
                                            style="
                                                color: #999999;
                                                font-size: 12px;
                                            "
                                            >酬劳：</span
                                        >
                                        <template
                                            class="task-money"
                                            v-if="item.type.value === 10"
                                        >
                                            <span
                                                class="task-money"
                                                v-if="
                                                    item.marketHandleType
                                                        .value === 10
                                                "
                                                >赠送</span
                                            >
                                            <span
                                                class="task-money"
                                                v-if="
                                                    item.amount * 100 !== 0 &&
                                                    item.marketHandleType
                                                        .value === 10
                                                "
                                                >+</span
                                            >
                                            <span
                                                class="task-amount"
                                                v-if="item.amount * 100 !== 0"
                                                >￥{{ item.amount }}</span
                                            >
                                        </template>
                                        <template v-if="item.type.value === 20">
                                            <span class="task-money">赠送</span>
                                            <span
                                                class="task-money"
                                                v-if="
                                                    item.amount * 100 !== 0 &&
                                                    item.marketHandleType
                                                        .value === 10
                                                "
                                                >+</span
                                            >
                                            <span
                                                class="task-amount"
                                                v-if="item.amount * 100 !== 0"
                                                >￥{{ item.amount }}</span
                                            >
                                        </template>
                                    </template>
                                </div>
                                <div class="task-tags">
                                    <div
                                        v-for="label in item.labels"
                                        :key="label.id"
                                    >
                                        <div
                                            style="
                                                display: flex;
                                                flex-direction: row;
                                            "
                                        >
                                            <img
                                                v-if="label.attribute === '吃'"
                                                class="tags-icon"
                                                src="../assets/brandDetail/chi.png"
                                            />
                                            <img
                                                v-if="label.attribute === '穿'"
                                                class="tags-icon"
                                                src="../assets/brandDetail/chuang.png"
                                            />
                                            <img
                                                v-if="label.attribute === '用'"
                                                class="tags-icon"
                                                src="../assets/brandDetail/yong.png"
                                            />
                                            <img
                                                v-if="label.attribute === '行'"
                                                class="tags-icon"
                                                src="../assets/brandDetail/xing.png"
                                            />
                                            <img
                                                v-if="label.attribute === '乐'"
                                                class="tags-icon"
                                                src="../assets/brandDetail/le.png"
                                            />
                                            <img
                                                v-if="label.attribute === '玩'"
                                                class="tags-icon"
                                                src="../assets/brandDetail/wan.png"
                                            />
                                            <img
                                                v-if="label.attribute === '妆'"
                                                class="tags-icon"
                                                src="../assets/brandDetail/yong.png"
                                            />
                                            <div
                                                class="task-label"
                                                v-if="item.type.value === 10"
                                            >
                                                <span
                                                    style="margin: 0px 10px"
                                                    v-if="
                                                        item.marketHandleType
                                                            .value === 10
                                                    "
                                                    >价值{{
                                                        item.products[0].price /
                                                        100
                                                    }}元</span
                                                >
                                                <span
                                                    style="margin: 0px 10px"
                                                    v-if="
                                                        item.marketHandleType
                                                            .value === 20
                                                    "
                                                    >试用后，商品需回寄</span
                                                >
                                                <span
                                                    style="margin: 0px 10px"
                                                    v-if="
                                                        item.marketType
                                                            .value === 10
                                                    "
                                                    >图文直发</span
                                                >
                                            </div>
                                            <div
                                                class="task-label"
                                                v-if="item.type.value === 20"
                                            >
                                                <span style="margin: 0px 10px"
                                                    >价值{{
                                                        item.products[0].price /
                                                        100
                                                    }}元</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="task-logo"
                                    style="display: flex; flex-direction: row"
                                >
                                    <template v-if="item.platform.value === 10">
                                        <img
                                            class="platform-logo"
                                            src="../assets/taskDetail/xiaohongshu.png"
                                        />
                                        <span class="font-logo">小红书</span>
                                    </template>
                                    <template v-if="item.platform.value === 20">
                                        <img
                                            class="platform-logo"
                                            src="../assets/taskDetail/douyin.png"
                                        />
                                        <span class="font-logo">抖音</span>
                                    </template>
                                    <template v-if="item.platform.value === 30">
                                        <img
                                            class="platform-logo"
                                            src="../assets/taskDetail/kuaishou.png"
                                        />
                                        <span class="font-logo">快手</span>
                                    </template>
                                    <template v-if="item.platform.value === 40">
                                        <img
                                            class="platform-logo"
                                            src="../assets/taskDetail/weibo.jpeg"
                                        />
                                        <span class="font-logo">微博</span>
                                    </template>
                                    <template v-if="item.platform.value === 50">
                                        <img
                                            class="platform-logo"
                                            src="../assets/taskDetail/dazhong.png"
                                        />
                                        <span class="font-logo">大众</span>
                                    </template>
                                    <template v-if="item.platform.value === 60">
                                        <img
                                            class="platform-logo"
                                            src="../assets/taskDetail/weixin.png"
                                        />
                                        <span class="font-logo">微信</span>
                                    </template>
                                </div>
                                <div
                                    v-if="item.type.value === 20"
                                    class="task-address"
                                    style="
                                        color: #999999;
                                        font-size: 12px;
                                        display: flex;
                                        flex-direction: row;
                                        float: right;
                                        padding-top: 30px;
                                    "
                                >
                                    <img
                                        class="location-icon"
                                        src="../assets/brandDetail/location.png"
                                    />
                                    <span
                                        style="
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            width: 50px;
                                            white-space: nowrap;
                                        "
                                        >{{ item.merchantAddress }}</span
                                    >
                                    <span
                                        class="distance-box"
                                        v-if="item.distance"
                                    >
                                        <span>| {{ item.distance }}</span>
                                    </span>
                                    <span class="distance-box" v-else>
                                        <span>| 未知</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </template> -->

        <!-- end -->
        <template v-else>
            <!-- taskList -->
            <van-pull-refresh class="card-box" v-model="refreshing" @refresh="onRefresh">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="handleGetTaskList" >
                    <div v-for="item in taskList" :key="item.id" style=" box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);border-radius: 10px;">
                        <div class="item-container" @click="onTapItem(item.id, item.instantGuestFlag)">
                            <!-- <template v-if="item.instantGuestFlag">
                        <div class="instantFlag">
                            <img src="../assets/jike/sd.png" />
                            <span class="instant-span">即刻</span>
                        </div>
                    </template> -->
                            <div class="b-logo">
                                <van-image round use-loading-slot :src="item.productsImageUrl">
                                    <van-loading slot="loading" type="spinner" size="20" vertical />
                                </van-image>
                            </div>
                            <div class="task-content">
                                <span class="task-title">{{ item.name }}</span>
                                <div class="task-platform" :style="{ background: item.platformColor }">{{
                                    item.platform.desc }}
                                </div>
                                <div class="task-m">
                                    <template v-if="item.amount > 0">
                                        <span class="task-money">￥{{ item.amount }}</span>
                                    </template>
                                    <template v-else>
                                        <span class="task-money">置换</span>
                                    </template>
                                    <div style="margin-left:20px;">
                                        <img class="tags-icon" src="../assets/home/tags.png" />
                                        <span v-for="label in item.labels" :key="label.id" class="task-label">
                                            {{ label.name }}
                                        </span>
                                    </div>

                                </div>
                                <div style="height:1px;background-color: #ccc;"></div>
                                <div class="task-conditions">
                                    <div class="condition-item">
                                        <span class="condition-title">粉丝要求</span>
                                        <span v-if="item.fansMin" class="condition">{{ item.fansMin }}+</span>
                                        <span v-else class="condition">无限制</span>
                                    </div>
                                    <div class="condition-item">
                                        <span class="condition-title">招募人数</span>
                                        <span class="condition">{{ item.applyPeopleMax }}人</span>
                                    </div>
                                    <div class="time-from-now-box">
                                        <img class="time-icon" src="../assets/home/Shape.png" />
                                        <span class="times">{{ item.timeFromNow }}</span>
                                    </div>
                                </div>
                            </div>
                            <img v-if="item.type.value === 10" class="task-type-icon"
                                src="../assets/home/type_10.png" />
                            <img v-else-if="item.type.value === 20" class="task-type-icon"
                                src="../assets/home/type_20.png" />
                            <img v-else-if="item.type.value === 30" class="task-type-icon"
                                src="../assets/home/type_30.png" />
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </template>
    </div>
</template>
<script>
import axios from "@/utils/miniAxios";
import { fetchBrandById, fetchTask } from "@/services/brand";
import moment from "moment";
import { Toast } from "vant";
moment.locale("zh-cn");

export default {
    data() {
        return {
            platformColor: {
                10: "#FF0000",
                20: "#170B1A",
                30: "#FF8000",
                40: "#FFC862",
                50: "#FF6633",
                60: "#46BB36",
            },
            aMapKey: "b935c33888a4fdfcb1c6a424ddcd50bd",
            brandId: "",
            detailData: {},
            locationData: undefined,

            search40Form: {
                current: 1,
                size: 10,
                brandId: "",
                statuses: "50",
            },
            search50Form: {
                current: 1,
                size: 10,
                brandId: "",
                statuses: "30,40",
            },
            loading: false,
            finished: true,
            taskList: [],
            refreshing: false,
            no40More: false,
            no50More: false,
            task40List: [],
            task50List: [],
            currentTab: "进行中任务",
            attentionForm: {
                quoteId: "",
                type: 20,
            },
        };
    },
    mounted() {
        // const id = '1423271424147943425'
        this.brandId = this.$route.params.id;
        const query = this.$route.params;
        this.attentionForm.quoteId = query.id;
        // this.brandId = id
        if (this.brandId) {
            this.getBrandDetail(this.brandId);
            this.onRefresh();
        }
    },
    methods: {
        handleAttentionChange() {
            let url = "/api/user/attentions";
            let showText = "收藏";
            let value = 1;
            if (this.detailData.attentionFlag.value === 1) {
                url += "/cancel";
                showText = "取消收藏";
                value = 0;
            }
            axios({
                url: url,
                method: "post",
                data: this.attentionForm,
            })
                .then((res) => {
                    Toast.success(showText + "成功");
                    this.detailData.attentionFlag.value = value;
                })
                .catch(() => { });
        },
        onTapItem(id, flag) {
            if (flag) {
                this.$router.push({
                    path: "/instantTaskDetail",
                    query: {
                        id,
                        // lat: this.locationData.lat,
                        // lng: this.locationData.lng
                    },
                });
                // this.$router.push(`/instantTaskDetail?id=${id}&location=${this.locationData}`)
            } else {
                this.$router.push(`/taskDetail/${id}`);
            }
        },
        getBrandDetail(id) {
            fetchBrandById(id).then((res) => {
                res.logo =
                    "https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/" +
                    res.logo;
                res.images =
                    "https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/" +
                    res.images;
                // res.labels = res.labels.map(item => item.name)
                this.detailData = res;
            });
        },
        onChange(name, title) {
            this.currentTab = name;
            if (name !== "品牌详情") {
                this.$nextTick(() => {
                    this.onRefresh();
                    // this.handleGetTaskList()
                });
            }
        },
        handleGetTaskList() {
            const currentStatus = this.currentTab === "进行中任务" ? 50 : 40;
            // if (this[`no${currentStatus}More`]) return
            const searchParams = this[`search${currentStatus}Form`];
            searchParams.brandId = this.brandId;
            // if (this.locationData) {
            //     searchParams.latitude = this.locationData.lat
            //     searchParams.longitude = this.locationData.lng
            // }
            if (this.refreshing) {
                this.taskList = [];
                searchParams.current = 1;
                this.refreshing = false;
            }
            fetchTask(searchParams)
                .then((res) => {
                    res.records = res.records.map((item) => {
                        return {
                            ...item,
                            platformColor:
                                this.platformColor[item.platform.value],
                                timeFromNow:item.gmtCreate.split(' ')[0],
                            // timeFromNow: moment(
                            //     item.gmtCreate,
                            //     "YYYY-MM-DD HH:mm:ss"
                            // ).fromNow(),
                            amount:item.amount / 100,
                            brandLogoUrl:
                                "https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/" +
                                item.brandLogoUrl,
                            productsImageUrl:
                                "https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/" +
                                item.products[0].imageUrl,
                            distance: item.distance
                                ? (item.distance / 1000).toFixed(2) + " km"
                                : "",
                        };
                    });
                    // let resultList = this[`task${currentStatus}List`]
                    let resultList = this.taskList;
                    resultList = resultList.concat(res.records);
                    this.loading = false;
                    this[`search${currentStatus}Form`].current++;
                    if (resultList.length >= res.total) {
                        this.finished = true;
                    }
                    this.taskList = resultList;
                    // if (resultList.length >= res.total) {
                    //     this.data[`no${currentStatus}More`] = true
                    // } else {
                    //     this.data[`no${currentStatus}More`] = false
                    // }
                    // this[`task${currentStatus}List`] = resultList
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onRefresh() {
            this.finished = false;
            this.loading = true;
            this.refreshing = true;
            // const currentStatus = this.currentTab === '已结束任务' ? 50 : 40
            // this[`search${currentStatus}Form`].current = 1
            // this[`no${currentStatus}More`] = false
            this.handleGetTaskList();
        },
    },
};
</script>
<style lang="less">
.brand-detail-container {
    background: #f7f7f7;
    //padding: 0 20px;
    //padding-top: 15px;
}

.card-box {
    background: #ffffff;
    margin-bottom: 10px;
    padding: 13px 15px;
}

.card-boxTwo {
    background: #ffffff;
    margin-bottom: 10px;
    padding: 13px 15px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}

.brand-detail-top {
    position: relative;
    margin-top: -30px;

    .top-box {
        display: flex;
        padding: 13px 15px;
        padding-bottom: 40px;
        border-bottom: 1px solid #eeeeee;

        .brand-logo {
            width: 90px;
            height: 90px;
            border-radius: 5px;
        }

        .top-left {
            flex: 1;

            .label {
                display: inline-block;
                min-width: 28px;
                height: 14px;
                line-height: 14px;
                text-align: center;
                padding: 0 5px;
                background: #ff6d26;
                border-radius: 2px;
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
            }

            .name {
                font-size: 17px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #171f24;
                padding-bottom: 4px;
            }

            .merchantCompanyName {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #6d7278;
            }
        }
    }
}

.brand-detail-top .bottom-box-brand {
    height: 88px;
    display: flex;

    .item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .value {
            font-size: 17px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #171f24;
        }

        .label {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6d7278;
        }

        img {
            width: 24px;
            height: 24px;
        }
    }
}

.brand-detail-top .brand-introduction {
    height: 112px;
}

.brand-introduction .brand-introduction-title {
    font-size: 16px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
}

.brand-introduction .brand-introduction-detail {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6d7278;
    display: block;
    margin-bottom: 10px;
    margin-top: 10px;
}

.brand-tabs-container {
    margin-top: 10px;

    .van-tabs__wrap {
        height: 32px !important;
        margin: 0 auto;
        border-radius: 7px;
        background: #6d7278;
        //border: 1px solid #D8D8D8;
    }

    .van-ellipsis {
        line-height: 32px;
    }

    .van-tab--active {
        //background: linear-gradient(180deg, #FF6D26 0%, #F7B500 100%);
        //border-radius: 7px;
        color: #17C2CF;
        font-weight: bold;

        .van-ellipsis {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
        }
    }

    .van-tabs__line {
        display: none;
    }
}

.info-container .title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    padding: 17px 0;
}

.info-container .introduction {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6d7278;
    display: block;
    margin-bottom: 14px;
}

.info-container .card-box {
    padding: 10px 15px;
}

.info-container .card-box .title {
    padding: 0;
    padding-bottom: 10px;
}

rich-text .rich-img {
    width: 100%;
    height: auto;
}

.brand-detail-title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    padding-bottom: 10px;
}

/* 任务列表 start */
.item-container {
    display: flex;
    /* height: 280rpx; */
    background: #ffffff;
    border-radius: 10px;
    margin: 10px 0;
    position: relative;
    border-bottom: 1px solid #eeeeee;
}

.b-logo {
    width: 61px;
    margin-right: 20px;
}

.b-logo .van-image {
    height: 44px;
    width: 44px;
    margin: 10px 20px;
}

.van-image__error,
.van-image__img,
.van-image__loading {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.task-content {
    flex: 1;
    padding-top: 15px;
}

.task-content .task-title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #000000;
    line-height: 20px;
    display: block;
    padding-right: 25px;
}

.task-content .task-platform {
    display: inline-block;
    min-width: 36px;
    // padding: 0 5px;
    height: 20px;
    border-radius: 3px;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    margin-left: -5px;
    color: #ffffff;
    padding: 0 10px;
    margin: 5px 0;
}

.sign-total {
    display: flex;
    flex-direction: row;
    padding-top: 5px;
}

.label-sign {
    width: 66px;
    height: 20px;
    line-height: 20px;
    // background: linear-gradient(180deg, #ff6d26 0%, #f7b500 100%);
    background-color: #17C2CF;
    color: #ffffff;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 12px;
    border-radius: 2px;
    text-align: center;
    margin-right: 10px;
}

.task-content .task-m {
    display: flex;
    flex-direction: row;
    padding: 12px 0 7px 0;
    align-items: center;
}

.task-money {
    font-size: 18px;
    color: #ff6d26;
    font-weight: bold;
    font-family: PingFangSC-Medium;
}

.task-amount {
    font-family: ArialMT;
    font-size: 20px;
    color: #17C2CF;
    font-weight: bold;
}

.task-tags .tags-icon {
    width: 20px;
    height: 20px;
}

.task-tags .task-label {
    text-align: center;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #333333;
    background-color: #f4e9cb;
    border-radius: 2px;
}

.task-logo {
    // position: absolute;
    bottom: 20px;
    height: 20px;
    margin-right: 10px;
    // line-height: 20px;
    // width: 100%;
}

.platform-logo {
    width: 20px;
    height: 20px;
    border-radius: 5px;
}

.font-logo {
    font-size: 12px;
    font-family: PingFangSC-Medium;
    font-weight: bold;
    height: 20px;
    line-height: 20px;
    align-items: center;
    margin-left: 5px;
}

.distance-box {
    flex: 1;
    text-align: right;
    padding-right: 10px;
    font-size: 12px;
    color: #999999;
}

.location-icon {
    width: 9px;
    height: 12px;
    margin-right: 5px;
}

.task-content .task-conditions {
    display: flex;
    align-items: center;
    padding: 11px 0;
}

.task-conditions .condition-item {
    padding-right: 15px;
    line-height: 8px;
}

.condition-item .condition-title {
    font-size: 10px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #999999;
    padding-right: 5px;
}

.condition-item .condition {
    font-size: 10px;
    font-family: ArialMT;
    color: #000000;
}

.task-conditions .time-from-now-box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.time-from-now-box .time-icon {
    width: 12px;
    height: 13px;
    margin-right: 5px;
}

.time-from-now-box .times {
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    padding-right: 10px;
}

.item-container .task-type-icon {
    width: 29px;
    height: 29px;
    position: absolute;
    top: 0;
    right: 0;
}

.instantFlag {
    position: absolute;
    right: 18px;
    top: 40px;
    border-radius: 4px;
    // border: 1px solid #ff6d26;
    border: 1px solid #17C2CF;
    height: 19px;
    width: 50px;
    text-align: center;
    line-height: 17px;

    img {
        width: 12px;
        vertical-align: middle;
    }

    .instant-text {
        font-size: 12px;
        color: #17C2CF;
    }
}

.richText {
    word-break: break-all;
}

.brand-show {
    width: 100%;
    height: 250px;
    opacity: 0.6;
    position: relative;
    z-index: 0;
}

.brand-show-logo {
    width: 88px;
    height: 88px;
    opacity: 1;
    border-radius: 50%;
}

.brand-show-name {
    color: #ffffff;
    font-weight: bold;
    font-family: PingFang-SC-Bold;
    font-size: 16px;
    margin-top: 10px;
}

.brand-show-merchantCompanyName {
    color: #ffffff;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    margin-top: 10px;
}

.brand-show-label {
    display: inline-block;
    min-width: 28px;
    height: 14px;
    line-height: 14px;
    text-align: center;
    padding: 0 5px;
    background: #17C2CF;
    border-radius: 2px;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    margin-left: 10px;
}
</style>
